
import EoButton from '../EoButton/EoButton'
import EoCard from '../EoCard/EoCard'
import EoIcon from '../EoIcon/EoIcon'
import EoImg from '../EoImg/EoImg'

export default {
  name: 'EoSearchResult',
  components: {
    EoButton,
    EoCard,
    EoIcon,
    EoImg,
  },
  props: {
    /**
     * Index with respect to total results
     */
    index: {
      type: Number,
      default: null,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Hyperlink to url, page or anchor tag
     */
    to: {
      type: String,
      default: null,
    },
    /**
     * Prefetches the page behind the link
     */
    prefetch: {
      type: Boolean,
      default: true,
    },
    /**
     * Target for the link: (_self) (_blank)
     */
    target: {
      type: String,
      default: '_self',
    },
    /**
     * Image source OR source set
     */
    image: {
      type: String,
      default: null,
    },
    /**
     * Title
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Genre
     */
    genre: {
      type: String,
      default: null,
    },
    /**
     * Category
     */
    category: {
      type: String,
      default: null,
    },
    /**
     * Topic
     */
    topic: {
      type: String,
      default: null,
    },
    /**
     * Multiline description or excerpt
     */
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    dynamicLinkTag () {
      if (this.to) {
        if (
          this.to.startsWith('https://') ||
          this.to.startsWith('http://') ||
          this.to.startsWith('tel:') ||
          this.to.startsWith('mailto:') ||
          this.to.startsWith('whatsapp:') ||
          this.to.startsWith('#') ||
          this.target.toLowerCase() === '_parent' ||
          this.target.toLowerCase() === '_top'
        ) {
          return 'a'
        }
        if (this.$root.$options.components.NuxtLink) {
          return 'nuxt-link'
        } else if (this.$root.$options.components.RouterLink) {
          return 'router-link'
        } else {
          return 'a'
        }
      }
      return 'div'
    },
    href () {
      if (this.dynamicLinkTag === 'a' || this.dynamicLinkTag === 'nuxt-link' || this.dynamicLinkTag === 'router-link') {
        return this.to || null
      } else {
        return null
      }
    },
    topicSlug () {
      const mapTopicSlug = {
        'Afscheid & Rouw': 'afscheid-en-rouw',
        'Geloven & Vragen': 'geloven-en-vragen',
        'Hier & Nu': 'hier-en-nu',
        'Natuur & Wetenschap': 'natuur-en-wetenschap',
        'Opgroeien & Gezin': 'opgroeien-en-gezin',
        'Oog voor anderen': 'oog-voor-anderen',
        'Vallen & Opstaan': 'vallen-en-opstaan',
        'Vieren & Herdenken': 'vieren-en-herdenken',
        'Zingen & Bidden': 'zingen-en-bidden',
      }

      return mapTopicSlug[this.topic] || null
    },
    tags () {
      return [...(this.category && [this.category]), ...(this.genre && [this.genre])].join(' | ')
    },
  },
}
